<script>
    import {reservation, steps} from '../stores/reservation-store';
    import isLoading from '../stores/loading-store';
      import {
        i18n,
    } from "svelte-translate";
    let submitted = false;
    const submission = () => {
       isLoading.set(true);
       document.getElementById('reservation-form').submit();
       submitted = true;
    }
</script>

<nav class="Reservation-navigation">
    {#if $steps.currentStep !== 1}<button type="button" class="button button--previous" disabled="{!$steps.previousStep}" on:click="{() => $steps.currentStep = $steps.previousStep}" use:i18n={"previousButtonLabel"}>&laquo; previous</button>{/if}
    {#if ($reservation.eventType !== "KOparty" && $steps.currentStep === 5) || ($reservation.eventType === "KOparty" && $steps.currentStep === 3)}
    <button type="button" class="button button--next" on:click="{() => submission() }" disabled="{submitted}" use:i18n={"confirmButtonLabel"}>confirm</button>
    {:else}
    <button type="button" class="button button--next" disabled="{!$steps.nextStepAllowed}" on:click="{() => $steps.currentStep = $steps.nextStep}" use:i18n={"nextButtonLabel"}>next &raquo;</button>
    {/if}
</nav>
